var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48.31 47.66",
    style: {
      enableBackground: "new 0 0 48.31 47.66"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#E5BDA0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 24.16,
    cy: 23.83,
    rx: 23.2,
    ry: 23
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.16,46.83c-12.79,0-23.2-10.32-23.2-23c0-12.68,10.41-23,23.2-23c12.79,0,23.2,10.32,23.2,23 C47.36,36.51,36.95,46.83,24.16,46.83z M24.16,3.83c-11.14,0-20.2,8.97-20.2,20c0,11.03,9.06,20,20.2,20s20.2-8.97,20.2-20 C44.36,12.8,35.29,3.83,24.16,3.83z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_463",
    className: "st1",
    d: "M30.82,18.73h-4.55v-2.98c-0.09-0.66,0.37-1.28,1.03-1.37c0.08-0.01,0.15-0.01,0.23-0.01 h3.21V9.44l-4.42-0.02c-4.91,0-6.03,3.67-6.03,6.03v3.28h-2.84v5.08h2.84v14.36h5.97V23.81h4.03L30.82,18.73z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookOut);
export default __webpack_public_path__ + "static/media/Facebook_Out.30ec8fce01c74f0f591a6d70aaf4351a.svg";
export { ForwardRef as ReactComponent };